/*
 * FIBRA6 — Produktseite
 *
 * Die Seite funktioniert ohne dieses Skript (Radiobuttons tragen die Varianten-ID,
 * das Formular geht zum Warenkorb). Mit Skript:
 *  - Preis, Knopf, gewählter Name, Stufe-2-Hinweis und Adresse (?variant=) folgen der Wahl,
 *  - die Galerie wischt zum Foto der Ausführung (nur wenn sie wischbar ist),
 *  - „In den Warenkorb" bleibt auf der Seite und meldet sich mit Link zum Warenkorb,
 *  - der Kopf erfährt die neue Anzahl (Ereignis „warenkorb:zahl").
 */
(() => {
  const wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const ruhig = matchMedia("(prefers-reduced-motion: reduce)");

  const melde = (el, text, art, link) => {
    el.hidden = false;
    el.dataset.art = art;
    el.textContent = text;
    if (link) {
      const a = document.createElement("a");
      a.href = link.href;
      a.textContent = link.text;
      el.append(a);
    }
  };

  const richteEin = (bereich) => {
    if (bereich.dataset.bereit) return;
    bereich.dataset.bereit = "1";

    const daten = bereich.querySelector("[data-varianten]");
    const formular = bereich.querySelector("[data-produkt-formular]");
    if (!daten || !formular) return;

    const varianten = JSON.parse(daten.textContent);
    const versteckt = formular.querySelector("[data-variante]");
    const preis = bereich.querySelector("[data-preis]");
    const knopf = bereich.querySelector("[data-kaufen]");
    const knopfText = bereich.querySelector("[data-kaufen-text]");
    const knopfStandard = knopfText ? knopfText.textContent : "";
    const meldung = bereich.querySelector("[data-meldung]");
    const galerie = bereich.querySelector("[data-galerie]");
    const felder = [...bereich.querySelectorAll("fieldset[data-option]")];

    const gewaehlteWerte = () =>
      felder.map((f) => f.querySelector("input:checked")?.dataset.wert ?? null);

    const aktualisiere = () => {
      const werte = gewaehlteWerte();
      const v = varianten.find((kandidat) => kandidat.optionen.every((o, i) => o === werte[i]));

      felder.forEach((f, i) => {
        const anzeige = f.querySelector("[data-gewaehlt]");
        if (anzeige) anzeige.textContent = werte[i] ?? "";
      });

      // Zeilen, die zur gewählten Ausführung gehören: Stufe, Limitierung.
      // Sie stehen auch außerhalb der Auswahl, darum im ganzen Bereich suchen.
      for (const h of bereich.querySelectorAll("[data-wert-hinweis]")) {
        h.hidden = !werte.includes(h.dataset.wertHinweis);
      }

      if (meldung) meldung.hidden = true;

      if (!v) {
        knopf.disabled = true;
        knopfText.textContent = "Nicht verfügbar";
        return;
      }

      if (versteckt) versteckt.value = v.id;
      knopf.disabled = !v.verfuegbar;
      knopfText.textContent = v.verfuegbar ? knopfStandard : "Vergriffen";

      if (preis) {
        if (v.preis) preis.textContent = v.preis;
        else preis.innerHTML = '<span class="offen">[Preis]</span>';
      }

      const adresse = new URL(location.href);
      adresse.searchParams.set("variant", v.id);
      history.replaceState(history.state, "", adresse);

      // Galerie zum Foto der Ausführung, nur wenn sie seitlich wischbar ist (Handy)
      if (v.medium && galerie && galerie.scrollWidth > galerie.clientWidth) {
        const ziel = galerie.querySelector(`[data-medium="${v.medium}"]`);
        if (ziel) galerie.scrollTo({ left: ziel.offsetLeft - galerie.offsetLeft, behavior: ruhig.matches ? "auto" : "smooth" });
      }
    };

    bereich.addEventListener("change", (e) => {
      if (e.target.closest("fieldset[data-option]")) aktualisiere();
    });

    formular.addEventListener("submit", async (e) => {
      if (!window.fetch) return;
      e.preventDefault();
      if (knopf.disabled) return;

      knopf.disabled = true;
      knopf.setAttribute("aria-busy", "true");

      try {
        const antwort = await fetch(`${wurzel}cart/add.js`, {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(formular),
        });
        const ergebnis = await antwort.json();

        if (!antwort.ok) {
          melde(meldung, ergebnis.description || ergebnis.message || "Das hat nicht geklappt.", "fehler");
          return;
        }

        melde(meldung, "Im Warenkorb.", "ok", { href: `${wurzel}cart`, text: "Zum Warenkorb" });

        const warenkorb = await (await fetch(`${wurzel}cart.js`, { headers: { Accept: "application/json" } })).json();
        document.dispatchEvent(new CustomEvent("warenkorb:zahl", { detail: warenkorb.item_count }));
      } catch {
        // Netz weg o. Ä.: klassisch absenden, der Server übernimmt
        formular.submit();
      } finally {
        knopf.removeAttribute("aria-busy");
        const werte = gewaehlteWerte();
        const v = varianten.find((k) => k.optionen.every((o, i) => o === werte[i]));
        knopf.disabled = v ? !v.verfuegbar : false;
      }
    });
  };

  const erfasse = (w) => w.querySelectorAll("[data-produkt]").forEach(richteEin);
  erfasse(document);
  document.addEventListener("shopify:section:load", (e) => erfasse(e.target));
})();
